import { DraftCharge as ServerDraftCharge, DraftChargeOptions } from 'server/models/DraftCharge';
import { NumberOfUnits, TotalPriceForCharge } from 'data/models/Charge';
import { ImmutablePrice } from 'data/models/Price';
import { IQuickBooksInventoryItemTracking, QuickBooksInventoryItemTrackingWithDefaults } from 'data/models/QuickBooksInventoryItemTracking';

export { DraftChargeData, DraftChargeOptions } from 'server/models/DraftCharge';

// TH 05/04/2017 -- NOTE: I originally defined DraftCharge in the same .cs file as DraftChargeCollection.
// That caused a problem w/ our client-side TS models.
// The issue is that I added custom methods to DraftCharge here.
// As a result, the DraftChargeCollection in server/models referenced the wrong version of DraftCharge.
// I.e., it referenced the version from server/models instead of from data/models.
// This caused typing errors downstream.
// That's currently a limitation in our _models.tst. And even if we changed _models.tst, we'd end
// up creating circular references between server/models and data/models that would require some thought.
// For now, my way of avoiding the issue was just to split the server-side classes into two separate files,
// thus generating separate files in server/models and data/models too.
export class DraftCharge extends ServerDraftCharge {
    QBTracking : IQuickBooksInventoryItemTracking;
    Total : ImmutablePrice;

    constructor();
    constructor(data : DraftChargeOptions);
    constructor(data : DraftChargeOptions | null = null) {
        super(data || { Id: 0 });

        this.QBTracking = QuickBooksInventoryItemTrackingWithDefaults(this.QBTrackingOverrides, () => this.StandardItem() && this.StandardItem()!.QBTracking);
        this.Total = TotalPriceForCharge(this);
    }

    NumberOfUnits() {
        return NumberOfUnits(this);
    }
}


// WEBPACK FOOTER //
// ./data/models/DraftCharge.ts